import { render, staticRenderFns } from "./WalletGeneralSettings.vue?vue&type=template&id=dafa1b78&"
import script from "./WalletGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./WalletGeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./WalletGeneralSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports